import { VALID, ValidationFields } from "../types/package";
import { validationCallback } from "./validationHelper";

export function validateFieldValue(value: any, validations: ValidationFields) {
  const errorMsgArr: string[] = [];
  Object.entries(validations || {}).forEach((validation) => {
    const [validationKey, validationValue] = validation as [
      keyof ValidationFields,
      ValidationFields[keyof ValidationFields]
    ];
    {
      const isCustomFunction = typeof validationValue === "function";
      const customMsg =
        typeof validationValue === "boolean"
          ? undefined
          : typeof validationValue === "string"
          ? validationValue
          : isCustomFunction
          ? undefined
          : validationValue?.message;
      const valueMaybe = isCustomFunction
        ? validationValue
        : typeof validationValue === "string" ||
          typeof validationValue === "boolean"
        ? undefined
        : validationValue?.value;
      const validationFn = validationCallback[validationKey];
      const msg = validationFn?.(value, customMsg, valueMaybe);
      if (msg !== VALID) {
        errorMsgArr.push(msg);
      }
    }
  });
  const err = errorMsgArr.length > 0 ? errorMsgArr : undefined;
  return err;
}
